import React, { useEffect, useState } from 'react';
import { API_DEFAULT } from "../config/xano";
import { IconTrash } from '@tabler/icons-react';
import { useObjectStore } from "../zustand/objects";

import { Button, Text, Group, FileButton, ActionIcon, Box, Stack, SimpleGrid } from '@mantine/core';
import {
    editorModalPrimaryButtonCompactStyles,
    editorModalPrimaryButtonStyles,
    editorModalGalleryPanelStyle,
    editorModalThumbFrameStyle,
    editorModalFootnoteBoxStyle,
} from "../styleFile";

import { nanoid } from 'nanoid'

const ImagesAPIMapped = ({ id }) => {

    const {
        updateObjectSelected,
        transformModeChange,
        addObject,
        updateImageTexture,
        updateImageObjectURL,
        currentObjectArtboard,
        imagePurpose,
        editingID,
        setEditingID,
        arrangeUndoRedo
    } = useObjectStore();

    const missedShape = () => {
        updateObjectSelected('0')
        transformModeChange({
            transformMode: "translate"
        })
    };

    const [imageURLs, setImageURLs] = useState([])
    const [readyToMap, setReadyToMap] = useState(false)

    const [sizeAlert, setSizeAlert] = useState(false)
    const [uploadAlert, setUploadAlert] = useState(false)


    // GET ALL A USER'S IMAGES
    const getUserImagesAPI = () => {
        return fetch(API_DEFAULT + '/image', {
            method: 'GET',
            headers: {
                "content-type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem('user')}`
            },
        })
            .then((response) => response.json())
            .then(data => setImageURLs([...data]))
            .then(() => setReadyToMap(true))
            .catch((error) => {
                console.error("Error:", error);
            });
    }


    // CREATE A NEW IMAGE RECORD
    const createNewImageRecord = (data) => {
        fetch(API_DEFAULT + '/image', {
            method: 'POST',
            body: data,
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('user')}`
            }
        }).then((response) => response.json())
            .then((result) => {
                getUserImagesAPI(localStorage.getItem('user'))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    // DELETE AN IMAGE RECORD 
    const deleteImageRecord = (data) => {
        fetch(`${API_DEFAULT}/image/${data}`, {
            method: 'DELETE',
            headers: {
                "content-type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem('user')}`
            }
        })
            .then((response) => response.json())
            .then((result) => {
                getUserImagesAPI(localStorage.getItem('user'))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }


    const handleSubmit = (e) => {
        createNewImageRecord(e)
    }

    useEffect(() => {
        getUserImagesAPI()
    }, []);

    useEffect(() => {
        imageURLs.length >= 12 ? setUploadAlert(true) : setUploadAlert(false)
    }, [imageURLs.length]);


    const addImageObject = (val, val2) => {
        const newID = nanoid()
        // send update to zustand first (so we have state to grab for undo array)
        addObject({ id: newID, currentObjectArtboard: currentObjectArtboard, undo: false, category: "image", image: val, imageSize: val2, object: "image", bGColour: null, pose: { name: null, modelPath: null } })
        // send current state to undoActions
        arrangeUndoRedo({
            updateType: "objectAdd",
            artboard: currentObjectArtboard,
            objectID: newID,
            undo: false
        })
        // setImagePurpose(null)
    }
    const addImageTexture = (val) => {
        // send current state to undoActions
        arrangeUndoRedo({
            updateType: "objectUpdate",
            artboard: currentObjectArtboard,
            objectID: editingID,
            undo: false,
            field: "imageTexture"
        })
        // send update to zustand
        updateImageTexture(editingID, currentObjectArtboard, val, false)
        // setImagePurpose(null)
        setEditingID(null)
        missedShape()
    }
    const editImageObjectURL = (val, val2) => {
        updateImageObjectURL(editingID, currentObjectArtboard, val, val2, false)
        // setImagePurpose(null)
        setEditingID(null)
        missedShape()
    }

    const deleteImage = (id) => {
        deleteImageRecord(id)
    }

    const sectionTitle =
        imagePurpose === "objectEdit"
            ? "Replace or add from your library"
            : imagePurpose === "texture"
                ? "Choose a texture image"
                : "Upload your own image";

    return (
        <div>
            <Box style={editorModalGalleryPanelStyle}>
                {!readyToMap || imageURLs.length === 0 ? (
                    <Text size="sm" c="dimmed" ta="center" py={32} px="md" style={{ lineHeight: 1.5 }}>
                        {readyToMap ? "No images yet. Upload a PNG or JPEG below." : "Loading your library…"}
                    </Text>
                ) : (
                    <SimpleGrid cols={{ base: 2, sm: 4 }} spacing={12}>
                        {imageURLs.map((imageSrc, i) => (
                            <Stack key={i} gap={10} align="center">
                                <Box style={editorModalThumbFrameStyle}>
                                    <img
                                        alt=""
                                        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                        src={imageSrc.image.url}
                                    />
                                </Box>
                                <Group gap={8} justify="center" wrap="nowrap">
                                    <Button
                                        onClick={() =>
                                            imagePurpose === "object"
                                                ? addImageObject(imageSrc.image.url, imageSrc.image.meta)
                                                : imagePurpose === "texture"
                                                    ? addImageTexture(imageSrc.image.url)
                                                    : editImageObjectURL(imageSrc.image.url, imageSrc.image.meta)
                                        }
                                        styles={editorModalPrimaryButtonCompactStyles}
                                    >
                                        Add
                                    </Button>
                                    <ActionIcon
                                        variant="light"
                                        color="gray"
                                        size="md"
                                        radius="md"
                                        aria-label="Delete image"
                                        onClick={() => deleteImage(imageSrc.id)}
                                    >
                                        <IconTrash size={18} />
                                    </ActionIcon>
                                </Group>
                            </Stack>
                        ))}
                    </SimpleGrid>
                )}
            </Box>
            <Stack gap="md" p={20}>
                <Text size="sm" fw={600} c="var(--mbx-modal-primary-text, #111827)">
                    {sectionTitle}
                </Text>
                <Group gap="sm" wrap="wrap" align="center">
                    <FileButton
                        accept="image/png,image/jpeg"
                        onChange={(e) => {
                            const form = new FormData();
                            if (e.size > 1097152) {
                                setSizeAlert(true);
                            } else {
                                setSizeAlert(false);
                                form.append("image", e, "image_upload.png");
                                e && handleSubmit(form);
                            }
                        }}
                    >
                        {(props) => (
                            <Button {...props} disabled={uploadAlert} radius="md" styles={editorModalPrimaryButtonStyles}>
                                Upload
                            </Button>
                        )}
                    </FileButton>
                </Group>
                <Box
                    p="md"
                    style={{
                        ...editorModalFootnoteBoxStyle,
                        backgroundColor: "var(--mbx-modal-muted-fill, #f9fafb)",
                    }}
                >
                    <Stack gap={6}>
                        <Text size="xs" c="dimmed" style={{ lineHeight: 1.55 }}>
                            PNG or JPEG, max 1&nbsp;MB. Up to 12 images in your library.
                        </Text>
                        {uploadAlert ? (
                            <Text c="red" size="xs" fw={500}>
                                Library full — remove an image to upload another.
                            </Text>
                        ) : null}
                        {sizeAlert ? (
                            <Text c="red" size="xs" fw={500}>
                                This file is over 1&nbsp;MB.
                            </Text>
                        ) : null}
                    </Stack>
                </Box>
            </Stack>
        </div>
    );
}

export default ImagesAPIMapped